(ns client-onboard.events
  (:require
    [very.re-frame.core :as rf]
    [graphql.core :as qu]
    ))

{:step (range 10)
 :can-begin? false
 }

(def step->key {0 :splash
                1 :risk/survey
                2 :risk/summary
                3 :priorities

                4 :finances/income
                5 :finances/expenses
                6 :finances/assets-&-liabilities
                7 :finances/insurance
                8 :finances/estate-&-tax

                9 :whats-new
                10 :key-accomplishments
                11 :success
                })

(def key->title {:splash ""
                 :risk/survey "Risk Survey"
                 :risk/summary "Risk Survey"
                 :priorities "Priorities & Goals"

                 :finances/income "Finances"
                 :finances/expenses "Finances"
                 :finances/assets-&-liabilities "Finances"
                 :finances/insurance "Finances"
                 :finances/estate-&-tax "Finances"

                 :whats-new "What's new"
                 :key-accomplishments "What's new"
                 :success "Success"
                 })

(rf/reg-sub
  :onboard/state
  (fn [db]
    (:onboard db)))

;; this flow is a little tricky. most users will come to the app
;; unauthenticated, but via a /onboard/:unique-invite-key link. we want to
;; preserve that invite link while also reusing the normal login flow. we can
;; setup a flow to watch for successfull auth-- after which we can redirect to
;; the provided /onboard/:key uri, and follow the simpler path where a user is
;; already authenticated for onboarding
(rf/reg-event-fx
  :onboard/unauthenticated
  (fn [cfx]
    {:async-flow {:id :onboard/unauthenticated
                  :rules [{:when :seen?
                           :events :session-created
                           :dispatch [:onboard/authenticated]
                           :halt? true}]}
     :nav! "/login"}))

(rf/reg-event-fx
  :onboard/authenticated
  (fn [cfx]
    {:redirect! "/onboard"}))

(rf/reg-event-fx
  :onboard/init
  (fn [cfx]
    {:graphql {:gql (qu/onboard)
               :success [:onboard/maybe-onboard]
               }}))

(rf/reg-event-fx
  :onboard/maybe-onboard
  (fn [cfx [data]]
    (if (get-in data [:client :onboard :required])
      {:dispatch [:onboard/onboard-user]}
      {:nav! "/dashboard"
       :dispatch [:error-message "You have already completed the annual review process for this year."]})))

(rf/reg-event-fx
  :onboard/onboard-user
  (fn [cfx]
    {:async-flow {:id :onboard/onboard-user
                  :rules [{:when :seen-all-of?
                           :events [
                                    :risk-profile/fetched
                                    :priorities/fetched
                                    :income/fetched
                                    :expenses/fetched
                                    :assets/fetched
                                    :liabilities/fetched
                                    :insurance/fetched
                                    :estate/fetched
                                    :tax/fetched
                                    :review/fetched]
                           :dispatch [:onboard/ready]
                           :halt? true}
                          {:when :seen-any-of?
                           :events [
                                    :risk-profile/fetch-errored
                                    :priorities/fetch-errored
                                    :income/fetch-errored
                                    :expenses/fetch-errored
                                    :assets/fetch-errored
                                    :liabilities/fetch-errored
                                    :insurance/fetch-errored
                                    :estate/fetch-errored
                                    :tax/fetch-errored
                                    :review/fetch-errored]
                           :dispatch [:onboard/ready]
                           :halt? true}]}
     :entity [{:type :risk-profile
               :op :get}
              {:type :priorities
               :op :get}
              {:type :income
               :op :get}
              {:type :expenses
               :op :get}
              {:type :assets
               :op :get}
              {:type :liabilities
               :op :get}
              {:type :insurance
               :op :get}
              {:type :estate
               :op :get}
              {:type :tax
               :op :get}
              {:type :review
               :op :get}]
     :db (assoc (:db cfx) :onboard {:step 0
                                    :can-begin? false})}))

(rf/reg-event-db
  :onboard/ready
  (fn [db]
    (assoc-in db [:onboard :can-begin?] true)))

(rf/reg-event-fx
  :onboard/start
  (fn [cfx]
    {:db (assoc-in (:db cfx) [:onboard :step] 1)}))

(rf/reg-event-db
  :onboard/prev
  (fn [db]
    (update-in db [:onboard :step] dec)))

(rf/reg-event-fx
  :onboard/next
  (fn [cfx]
    {:db (update-in (:db cfx) [:onboard :step] inc)}))

(rf/reg-event-fx
  :onboard/update-risk-survey
  (fn [cfx [data]]
    {:entity {:type :risk-profile
              :op :patch
              :data (select-keys data [:growth :concerns :knowledge
                                       :tradeoff :loss-anxiety
                                       :timeframe :expenses])
              :success [:onboard/next]
              }}))

(rf/reg-event-fx
  :onboard/update-priorities
  (fn [cfx [priorities]]
    {:entity {:type :priorities
              :op :patch
              :data priorities
              :success [:onboard/next]
              }}))

(rf/reg-event-fx
  :onboard/update-income
  (fn [cfx [income]]
    {:entity {:type :income
              :op :patch
              :data (select-keys income [:client :spouse])
              :success [:onboard/next]
              }}))

(rf/reg-event-fx
  :onboard/update-expenses
  (fn [cfx [expenses]]
    {:entity {:type :expenses
              :op :patch
              :data expenses
              :success [:onboard/next]
              }}))

(rf/reg-event-fx
  :onboard/update-assets-and-liabilities
  (fn [cfx [{:keys [assets liabilities]}]]
    {:entity [{:type :assets
               :op :patch
               :data assets}
              {:type :liabilities
               :op :patch
               :data liabilities}]
     :async-flow {:id :onboard/a&l
                  :rules [{:when :seen-both?
                           :events [:assets/updated
                                    :liabilities/updated]
                           :dispatch [:onboard/next]
                           :halt? true}
                          ;; clean up after ourselves if exiting early
                          {:when :seen?
                           :events :onboard/prev
                           :halt? true}]}}))

(rf/reg-event-fx
  :onboard/update-insurance
  (fn [cfx [insurance]]
    {:entity {:type :insurance
              :op :patch
              :data insurance
              :success [:onboard/next]
              }}))

(rf/reg-event-fx
  :onboard/update-estate-and-tax
  (fn [cfx [{:keys [estate tax]}]]
    {:entity [{:type :estate
               :op :patch
               :data estate}
              {:type :tax
               :op :patch
               :data tax}]
     :async-flow {:id :onboard/e&l
                  :rules [{:when :seen-both?
                           :events [:estate/updated
                                    :tax/updated]
                           :dispatch [:onboard/next]
                           :halt? true}
                          ;; clean up after ourselves if exiting early
                          {:when :seen?
                           :events :onboard/prev
                           :halt? true}]}}))

(rf/reg-event-fx
  :onboard/update-whats-new
  (fn [cfx [data]]
    {:entity {:type :review
              :op :post
              :data data
              :success [:onboard/next]}}))

(rf/reg-event-fx
  :onboard/create-key-accomplishments
  (fn [cfx [data]]
    (if-not (empty? data)
      {:entity {:type :key-accomplishments
                :op :post
                :data data
                :success [:onboard/next]}}
      {:dispatch [:onboard/next]})))

(rf/reg-event-fx
  :onboard/finish
  (fn [cfx]
    {:graphql {:gql (qu/update-onboard {:input {:finished true}})
               :success [:noop]}
     :nav! "/dashboard"}))
